import {
  SlBadge
} from "./chunk.IY7ZNK2P.js";

// src/components/badge/badge.ts
var badge_default = SlBadge;
SlBadge.define("sl-badge");

export {
  badge_default
};
